//FB 4487 DK - Removed multiple unused imports below
import React, { useContext, useState } from "react";
import Provider from "../components/Provider";
import {
  Grid,
  makeStyles,
  Typography,
  IconButton,
  Tooltip,
  CircularProgress,
  Button,
  Avatar,
  ThemeProvider,
  createMuiTheme,
  Card,
  CardContent,
  CardMedia,
  Paper,
} from "@material-ui/core";
import { Context, ErrorLog } from "../store";     //FB 4487 DK - Importing ErrorLog class from store
import NavigateBeforeIcon from "@material-ui/icons/ArrowBack";
import NavigateNextIcon from "@material-ui/icons/ArrowForward";
import ProviderScheduleRow from "./ProviderScheduleRow";
import { useHistory } from "react-router-dom";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import useStyle from "../css/styles";
import globalsettings from "../../../config";
// FB 4774 DK - Added reference to formatphone method
//FB-6264
import { formatphone, InsertPELogs, NotifyErrorOutage, GetAdminSettingValue } from "../api";      //FB 4487 DK - Importing the logError method used for error logging , FB 4960, FB 7418

// update log
// FB 4371 DK    03/29/2021    Added page for the slots page in "By Provider" workflow
// FB 4409 DK    04/27/2021    Implementation of loading spinner on slots page
// FB 4409 DK    04/30/2021    Added message to show when all available slots are booked
// FB 4487 DK    06/07/2021    Implemented error logging on api call failures
// FB 4574 DK    07/15/2021    Added styling for calender icon
// FB 4638 MS    08/31/2021    Fixed Mobile view issues
// FB 4735 DK    10/11/2021    Implementation of provider specific flow
// FB 4769 MS    11/02/2021    Added Job title for provider
// FB 4774 DK    11/16/2021    Modified the messages
// FB 4867 DK    01/20/2022    Phone numbe made clickable
// FB 4960 BR    07/03/2022    Logging all actions on PE
// FB 6264 DK    11/22/2022    Migrate PE API,DB to EMR
// FB 7418 GS    09/21/2023    Change the message on PE when slots are not available
// FB 7413 GA    09/25/2023    Orady - Update the map link to the correct one
// FB 7801 SK    12/14/2023    PE - Handling Appointment Types that have Differing Lengths of Time
// FB 7908 SK    01/08/2024    PE Online Appointment Bookings Facility Missing Address 2
// FB 8142 SK    01/23/2024    Sophie - time slots are different when you go with by date vs. by provider flow
// FB 8680 DK    05/21/2024    Practice phone related changes
// FB 9597 DK    10/24/2024    Schedules not loading on PE
// FB 9973 DK    01/28/2025    Failed to fetch: GET https://drsamemr.com/api/Provider/GetSlotsByDate



export type Schedule = {
  ScheduleDate: string;
  Slots: string[];
};

export type SchedulesTest = {
  Facility_N: number;
  Facility_Name: string;
  Facility_Address: string;
  Facility_Address2: string;//FB 7908
  Facility_Info: string;
  NextAvailability: string;
  IsInsuranceAccepted: boolean;
  SlotsDate: SlotsDate[];
  Scheduling_Phone: string;
  availableSlotsCount: number;    //FB 4409 DK - Added variable for available slots count
  Duration: number; //FB 4638 added appt duration field
  GOOGLE_MAPS_LINK: string; //FB 7413
};

export type SlotsDate = {
  ScheduleDate: string;
  Slots: string[];
  ApptTypeSlots: string[];//FB  7801
};
const useStyles = makeStyles((theme) => ({
  flexColumn: {
    display: "flex",
    flexDirection: "column",
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  container: {
    //width: "90%",
    margin: "0 auto",
    border: "1px solid rgb(0 0 0 / 25%)",
    backgroundColor: "#fff",
  },
  filter: {
    justifyContent: "flex-start",
    minHeight: "400px",
    minWidth: "10%",
    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
  },
  centered: {
    alignSelf: "center",
  },
  content: {
    flex: "1 0 auto",
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    marginLeft: "10px",
  },
  topBarItem: {
    alignSelf: "center",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
  },
  margin: {
    margin: theme.spacing(1),
  },
  topBarItem_Day: {
    color: "#A8ABAE",
    textTransform: "uppercase",
    fontWeight: 500,
    letterSpacing: ".1em",
    whiteSpace: "normal",
    fontSize: "10px",
  },
  navigateBackContainer: {
    height: "9vh",
    alignItems: "center",
    justifyContent: "center",
  },
  mainFilter: {
    minHeight: "9vh",
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(2),
  },
  mainFilter_Location_Caption: {
    color: "#A8ABAE",
    fontWeight: "bold",
  },
  slotsContainer: {
    //width: "90%",
    margin: "0 auto",
    //border: "1px solid rgb(0 0 0 / 25%)",
    backgroundColor: "#fff",
  },
  providerRowContainer: {
    overflowY: "scroll",
    minHeight: "40vh",
    maxHeight: "55vh",
  },
  timeSlotItem: {
    borderRadius: "16px",
    border: "0",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EDEEEE",
    padding: "10px",
    //width: "70%",
    fontSize: "smaller",
    //height: "25px",
  },
  datepickerroot: {
    "& .MuiIconButton-root": {
      color: "#18a2b8",
    },
    // FB 4574 DK - Added styling for increasing the icon size
    "& .MuiSvgIcon-root": {
      fontSize: "2rem"
    }
  },
  paper: {
    height: "auto",
    width: "auto",
    alignContent: "center",
    display: "flex",
    justifyContent: "center",
    border: "none",
    boxShadow: "none",
  },
  scrollbar: {
    "&::-webkit-scrollbar": {
      width: "6px",
      height: "10px",
      backgroundColor: "lightgray",
    },

    "&::-webkit-scrollbar-thumb:vertical": {
      backgroundColor: "rgba(0,0,0,.5)",
    },
  },
}));

interface singleDay {
  dateLabel: string;
  hiddenDateValue: string;
}

export type Provider = {
  //name: string;
  //id: number;
  //facility: Facility;
  //schedules: Schedule[];
  schedulesTest: SchedulesTest[];
};

export type Facility = {
  id: number;
  name: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipcode: string;
};

//FB 4371 DK    Added to get available slots for selected provider
export async function GetAvailableSlotsByProvider(
  limited: number,
  startDate: string,
  id: number,
  apptType: any,
  insurance: number,  //FB 7801
  appointment_type_n: number  //FB 7801
): Promise<SchedulesTest[]> {
  //FB-6264
  let url;
  if (apptType === "telederm") {
    url =
      globalsettings.emrAPI +
      `api/Provider/TeleHealth/GetSlotsForProvider/${id}/${startDate}/${limited}/${appointment_type_n}`;//FB 7801
  } else {
    url =
      globalsettings.emrAPI +
      `api/Provider/GetSlotsForProvider/${id}/${startDate}/${limited}/${insurance}/${appointment_type_n}`;//FB 7801
  }
  const response = await fetch(url);

  //FB 4487 DK - Added logic for logging the error's on API call - Start
  if (!response.ok) {
    //FB-6264
    NotifyErrorOutage();
    return Promise.reject();
  }
  else {
    let data = await response.json();
    data = data.sort(function (x: any, y: any) {
      // true values first
      return x.IsInsuranceAccepted === y.IsInsuranceAccepted ? 0 : x ? -1 : 1;
    });
    return data as SchedulesTest[];
  }
  //FB 4487 DK - Added logic for logging the error's on API call - End
}

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function Slots_byprovider() {
  const classes = useStyles();
  const [next7Days, setNext7Days] = React.useState<singleDay[]>([]);
  const [dateCounter, setDateCounter] = React.useState<number>(0);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [providerSchedules, setProviderSchedules] = React.useState<Provider>();
  const [todayDate, setToday] = React.useState<boolean>(false);
  let tempdays: singleDay[] = [];
  const [windowDimensions, setWindowDimensions] = React.useState(
    getWindowDimensions()
  );
  const { width, height } = windowDimensions;
  const [limited, setLimit] = React.useState<number>(7);
  const { state, dispatch } = useContext(Context);
  const [selectedDate, setSelectedDate] = useState<any>(null);
  //FB 7418 Begin
  const [textMessage, setTextMessage] = useState("");
  const [textValue, setTextValue] = useState(false);
  //FB 7418 End
  const styles = useStyle();
  const [defaultPhone, setDefaultPhone] = useState(""); //FB 8680

  //FB 4735 DK - Added to assign default provider info to state object
  if (state.defaultprovider.id > 0) {
    state.appointmentdetails.provider = state.defaultprovider;
  }

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
      action: {
        selected: "#8BD0DB",
        hover: "#5DBDCD",
      },
    },
  });

  //FB 4371 DK    Added to display the slots in a week range
  const constructDates = (dtCounter: number = dateCounter) => {
    let limit: number = dtCounter + 1;
    //alert(width);
    if (window.innerWidth < 500) {
      limit = dtCounter + 1;
      setLimit(1);
      //alert(limit);
    } else if (window.innerWidth > 500 && window.innerWidth < 800) {
      limit = dtCounter + 1;
      setLimit(1);
      //alert(limit);
    } else {
      limit = dtCounter + 7;
      setLimit(7);
      //alert(limit);
    }
    for (dtCounter; dtCounter < limit; dtCounter++) {
      let currentDate = new Date();
      //alert(limit);
      //alert("currentDate: " + selectedDate);
      if (
        selectedDate !== null &&
        selectedDate.toDateString() !== currentDate.toDateString()
      ) {
        currentDate = new Date(selectedDate);
      }
      let days = currentDate.getDate() + dtCounter;
      let value = new Date(currentDate.setDate(days));
      let splittedDate = value.toLocaleDateString().split("/");
      tempdays.push({
        dateLabel: value.toString().substring(0, 10),
        hiddenDateValue: `${splittedDate[0]}-${splittedDate[1]}-${splittedDate[2]}`,
      });
    }
    setNext7Days(tempdays);
    setDateCounter(dtCounter);
    today();
  };


  const handleDateChange = (date: any) => {
    if (date != null && date != "Invalid Date") {
      setSelectedDate(date);
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Changed the date to " + date.toDateString() + " in by provider flow");
      //FB 4960 End
    }
  };

  //FB 7418 Begin
  async function GetSlotsMessage() {
    var data = await GetAdminSettingValue("PE_Slot_Unavailable_Message");
    if (data != "") {
      setTextMessage(data);
      setTextValue(true);
    }
    //FB 8680
    var practicePhone = await GetAdminSettingValue("Default_Sch_Appt_Number");
    if (practicePhone != null) {
      setDefaultPhone(practicePhone);
    }
  }
  //FB 7418 End
  function today() {
    let currentDate = new Date();
    let days = currentDate.getDate();
    let value = new Date(currentDate.setDate(days));
    let splittedDate = value.toLocaleDateString().split("/");
    if (
      `${splittedDate[0]}-${splittedDate[1]}-${splittedDate[2]}` ===
      tempdays[0].hiddenDateValue
    ) {
      setToday(true);
    } else setToday(false);
  }
  function handleResize() {
    //alert("handleResize");
    setWindowDimensions(getWindowDimensions());
    //alert("Out " + window.innerWidth);
    //if(width < 450){
    //alert(window.innerWidth);
    //constructDates(0);
    //today();
    //}
  }

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);
    constructDates(0);
    GetSlotsMessage(); //FB 7418
    //alert("hhh");
    today();
    return () => window.removeEventListener("resize", handleResize);
  }, [window.innerWidth]);

  React.useEffect(() => {
    //alert("hello:"+ selectedDate);
    if (selectedDate !== null) {
      constructDates(0);
    }
  }, [selectedDate]);

  React.useEffect(() => {
    if (next7Days.length > 0) {
      setLoading(true);
      let temp: Provider = {
        schedulesTest: [],
      };
      //FB 9597
      let session_ApptN = sessionStorage.getItem("AppointmentType_N");//FB 7801
      let appt_type_n = session_ApptN != null && session_ApptN != 'undefined' ? Number(session_ApptN) : 0;
      //FB 9973
      //let custom_appt_type = sessionStorage.getItem("Enable PE Custom Appointments");//FB 8142
      setTimeout(() => {
        (async () => {
          temp.schedulesTest = await GetAvailableSlotsByProvider(
            limited,
            next7Days[0].hiddenDateValue,
            state.appointmentdetails.provider.id,
            state.appointmentdetails.appointmenttype,
            state.appointmentdetails.insurance.id,//FB 7801
            Number(appt_type_n) //FB 7801
          );
          //FB 7801 - Begin //FB 8142
          //FB 9973
          //if (custom_appt_type == "true") {
            for (const facility of temp.schedulesTest) {
              for (const slotsDate of facility.SlotsDate) {
                if (slotsDate.ApptTypeSlots.length >= 1) {
                  slotsDate.Slots = slotsDate.ApptTypeSlots.slice();
                }
                else {
                  slotsDate.Slots = [""];
                }
              }
            }
            setProviderSchedules(temp);
          //}
          //else {
          //  setProviderSchedules(temp);
          //}
          //FB 7801 - End
          setLoading(false);
        })();
      }, 1000);
    }
  }, [next7Days]);

  const history = useHistory();

  const handleGoBack = () => {
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Go Back - Slots page by provider flow");
    //FB 4960 End
    history.goBack();
  };

  const handleProceed = () => {
    history.push("/appointment/create/components/Demographics", state);
  };

  const scrollTo = (ref: any) => {
    if (ref /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };


  return (
    <React.Fragment>
      <section
        ref={scrollTo}
        style={{
          margin: "20px 20px 20px",
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card
              className={styles.slotspage_Card}
              style={{ boxShadow: "none" }}
            >
              <CardMedia
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "5%",
                }}
              >
                <Avatar
                  //style={{ margin: 5 }}
                  className={styles.slotspage_Avatar}
                  src={
                    "/Images/Providers/" +
                    state.appointmentdetails.provider.id +
                    ".jpg"
                  }
                />
              </CardMedia>
              <CardContent>
                <Typography variant="h6">
                  <b>{state.appointmentdetails.provider.name}</b>
                </Typography>
                {/* FB 4769 BEGIN */}
                <Typography style={{ fontSize: "smaller" }}>
                  {state.appointmentdetails.provider.job_title}
                </Typography>
                {/* FB 4769 END */}
                <Typography style={{ fontSize: "smaller" }}>
                  {state.appointmentdetails.provider.bio}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          style={{ display: window.innerWidth <= 768 ? "flex" : "none" }}
        >
          <Grid item xs={window.innerWidth === 768 ? 6 : 12}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <ThemeProvider theme={theme}>
                <KeyboardDatePicker
                  id="dateByProvider"
                  className={`${classes.datepickerroot} ${classes.topBarItem}`}
                  fullWidth
                  inputVariant="standard"
                  orientation="portrait"
                  value={selectedDate}
                  label="Pick different date"
                  onChange={(date) => handleDateChange(date)}
                  format="MM/dd/yyyy"
                  minDate={new Date()}
                  initialFocusedDate={null}
                  minDateMessage="Date should not be in past"
                />
              </ThemeProvider>
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          style={{ borderBottom: "1px solid rgb(0 0 0 / 25%)" }}
          direction="row"
          alignContent="center"
          justify={window.innerWidth > 768 ? "flex-end" : "center"}
        >
          <Grid
            item
            sm={3}
            md={3}
            style={{ display: window.innerWidth > 768 ? "flex" : "none" }}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <ThemeProvider theme={theme}>
                <KeyboardDatePicker
                  id="differentDate"
                  className={`${classes.datepickerroot} ${classes.topBarItem}`}
                  fullWidth
                  inputVariant="standard"
                  orientation="landscape"
                  value={selectedDate}
                  label="Pick different date"
                  onChange={(date) => handleDateChange(date)}
                  format="MM/dd/yyyy"
                  minDate={new Date()}
                  initialFocusedDate={null}
                  minDateMessage="Date should not be in past"
                />
              </ThemeProvider>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={2} sm={1} md={1}>
            {todayDate === false ? (
              <Tooltip title="Previous">
                <IconButton
                  aria-label="previous"
                  onClick={() =>
                    constructDates(
                      limited === 7 ? dateCounter - 14 : dateCounter - 2
                    )
                  }
                >
                  <NavigateBeforeIcon
                    className={styles.navigationArrows}
                    fontSize="large"
                  />
                </IconButton>
              </Tooltip>
            ) : (
              ""
            )}
          </Grid>
          <Grid
            item
            xs={6}
            sm={7}
            md={7}
            style={{ display: "flex" }}
            direction="row"
            //alignContent="space-around"
            justify="center"
          //spacing={5}
          >
            {next7Days.map((ele: singleDay, index: number) => {
              return (
                <Grid key={index} item sm={2} md={2}>
                  <Paper className={classes.paper}>
                    <span className={classes.topBarItem_Day}>
                      {ele.dateLabel.substring(0, 3)}
                    </span>
                  </Paper>
                  <Paper className={classes.paper}>
                    <span>{ele.dateLabel.substring(4, 10)}</span>
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
          <Grid item xs={2} sm={1} md={1}>
            <Tooltip title="Next">
              <IconButton aria-label="next" onClick={() => constructDates()}>
                <NavigateNextIcon
                  className={styles.navigationArrows}
                  fontSize="large"
                />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={3}
          style={{ display: "flex", minHeight: "40vh", marginTop: "15px" }}
          direction="row"
          alignContent="center"
          justify="center"
        >
          {loading ? (
            <Grid item xs={12} style={{ margin: "auto" }}>
              <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
              >
                <CircularProgress />
              </Grid>
            </Grid>
          ) : (
            <Grid
              item
              xs={12}
              className={classes.scrollbar}
              style={{ maxHeight: "70vh", overflowY: "auto" }}
            >
              {/* FB 4774 DK - modified condition*/}
              {providerSchedules?.schedulesTest.length === 0 ||
                providerSchedules?.schedulesTest[0].Facility_N === 0 ? (
                <Grid item xs={12} style={{ margin: "auto" }}>
                  <Grid
                    container
                    direction="column"
                    justify="center"
                    alignItems="center"
                  >
                    <div className={classes.timeSlotItem}>
                      {/* FB 7418 Begin */}
                      {!textValue ? (
                        <Typography
                          variant="subtitle2"
                          style={{ textAlign: "center" }}
                        >
                          {/* FB 4774 - Modified the message */}
                          {/* FB 4867 */}
                          There are no online appointments available for this provider. Please call {formatphone(providerSchedules.schedulesTest[0].Scheduling_Phone)} to book an appointment.
                        </Typography>) :
                        <Typography
                          variant="subtitle2"
                          style={{ textAlign: "center" }}
                        >
                          {/* FB 4774 - Modified the message */}
                          {/* FB 4867 */}
                          {/* FB 8680 */}
                          {providerSchedules.schedulesTest[0].Scheduling_Phone.length > 0 ? textMessage.replace("@practice_phone", providerSchedules.schedulesTest[0].Scheduling_Phone)
                            : textMessage.replace("@practice_phone", defaultPhone)}
                        </Typography>
                      }
                      {/* FB 7418 End */}
                    </div>
                  </Grid>
                </Grid>
              ) : (
                <></>
              )}
              {/* FB 4774 DK - Modified the condition to show messages - Start*/}
              {providerSchedules?.schedulesTest && providerSchedules.schedulesTest[0]?.Facility_N > 0 ? providerSchedules?.schedulesTest.map(
                (ele: SchedulesTest, index: number) => {
                  return (
                    <ProviderScheduleRow
                      Provider={providerSchedules}
                      Limited={limited}
                      Index={index}
                      ProviderId={state.appointmentdetails.provider.id}
                      ProviderName={state.appointmentdetails.provider.name}
                      isLoading={setLoading}    //FB 4409 DK - Added to update the isLoading flag on slots page
                    />
                  );
                }
              ) : <></>}
              {/* FB 4774 DK - Modified the condition to show messages - End*/}
            </Grid>
          )}
        </Grid>

        <Grid
          container
          spacing={2}
          className={styles.flexend_Grid}
          style={{ marginTop: 10, display: "flex" }}
        >
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={3}
            className={styles.flexend_Grid}
            style={{ marginTop: 10 }}
          >
            <Button
              onClick={handleGoBack}
              variant="contained"
              id="goBackByProvider"
              className={styles.navigationButton}
            >
              Go Back
            </Button>
          </Grid>
        </Grid>

        {/* FB 4867 DK - Removed unused code */}
      </section>
    </React.Fragment>
  );
}
